import type { FunctionComponent, ReactNode } from "react";

type Props = {
  children?: ReactNode;
  isRosettaLoading: boolean;
};

export const PlusPaywallSuspenseContent: FunctionComponent<Props> = ({
  children,
  isRosettaLoading,
}) => {
  if (isRosettaLoading) {
    const promise = new Promise(resolve => resolve(isRosettaLoading));
    // eslint-disable-next-line write-good-comments/write-good-comments
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw promise;
  } else {
    return children;
  }
};

PlusPaywallSuspenseContent.displayName = "PlusPaywallSuspenseContent";
